module.exports = __webpack_public_path__ + "img/blog-grid.ff1eee32.png";